/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Product_Not_Found_TitleInputs */

const en_product_not_found_title = /** @type {(inputs: Product_Not_Found_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Product not found`)
};

const de_product_not_found_title = /** @type {(inputs: Product_Not_Found_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Produkt nicht gefunden`)
};

/**
* | output |
* | --- |
* | "Product not found" |
*
* @param {Product_Not_Found_TitleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const product_not_found_title = /** @type {((inputs?: Product_Not_Found_TitleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Product_Not_Found_TitleInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_product_not_found_title(inputs)
	return en_product_not_found_title(inputs)
});